import { Box, NeoColor, P4 } from "@noom/wax-component-library";
import { useTranslation } from "react-i18next";

import type { UseTreatmentOverviewByCodeResult } from "../hooks/useTreatmentOverviewByCode";

import { DetailShell } from "./DetailShell";
import { TreatmentDetailErrorPanel } from "./TreatmentDetailErrorPanel";
import { TreatmentDetailSkeleton } from "./TreatmentDetailSkeleton";

type TreatmentDetailDeeplinkLoaderProps = {
  treatmentCode?: string;
  query: UseTreatmentOverviewByCodeResult;
};

export const TreatmentDetailDeeplinkLoader = ({
  treatmentCode,
  query,
}: TreatmentDetailDeeplinkLoaderProps) => {
  const { t, ready = true } = useTranslation("care", { useSuspense: false });
  const { loading, error, refetch } = query;

  if (!ready || loading) {
    return (
      <DetailShell>
        <TreatmentDetailSkeleton />
      </DetailShell>
    );
  }

  if (error) {
    return (
      <DetailShell>
        <TreatmentDetailErrorPanel
          message={t("errorState.connectionLost")}
          retryLabel={t("errorState.retry")}
          onRetry={refetch}
        />
      </DetailShell>
    );
  }

  return (
    <DetailShell>
      <Box width="100%" pt={3}>
        <Box bg={NeoColor.greyscale.white} borderRadius="12px" p={4}>
          <P4 color={NeoColor.greyscale.black}>
            {t("detail.notFound", { treatmentCode })}
          </P4>
        </Box>
      </Box>
    </DetailShell>
  );
};
